import { RouteLocationNormalized, Router } from 'vue-router'

import { GroupState } from '@/composition/groups'
import { navigation } from '@/composition/navigation'
import { UserState } from '@/composition/users'
import { emitter } from '@/main'
import { MemberStatus } from '@/models/Groups'

// Routes to be allowed on private groups with groupslug. [Routes without groupslug are allowed by default]
const allowRoutesOnPrivateGroup = [
  'NotificationMobileView',
  'user-profile',
  'clientportal-home',
  'profile-container',
  'communities-more',
  'conversations',
  'chat-view',
  'documents-and-payments',
]
export class RouterHelper {
  static async handleInactiveGroups(route, router): Promise<void> {
    if (
      route.params?.groupSlug &&
      GroupState.state.groupData?.status === 'Inactive' &&
      route.name !== 'inactive-group'
    ) {
      await router.push({
        name: 'inactive-group',
        params: { groupSlug: route.params.groupSlug },
      })
    }

    if (
      route.name === 'inactive-group' &&
      GroupState.state.groupData?.status !== 'Inactive'
    ) {
      await router.push({
        name: 'home',
        params: { groupSlug: route.params.groupSlug },
      })
    }
  }

  static async handlePrivateGroups(
    route: RouteLocationNormalized,
    router: Router,
    routeFrom?: RouteLocationNormalized
  ): Promise<void> {
    // Skip private group checks for my-courses route
    if (route.name === 'my-courses') {
      return
    }

    if (
      route.name === 'private-group' &&
      GroupState.state.groupData?.settings?.groupType !== 'Private'
    ) {
      await router.push({
        name: 'home',
        params: { groupSlug: route.params.groupSlug },
        query: route.query,
      })
    }
    if (
      GroupState.state.groupData?.settings?.groupType === 'Private' &&
      route.name !== 'private-group' &&
      route?.params?.groupSlug &&
      allowRoutesOnPrivateGroup.indexOf(route.name as string) === -1
    ) {
      if (!GroupState.state?.role && route.name !== 'home') {
        emitter.emit('access:private-group-unauthorized', {
          routeName: String(route.name),
          message: 'Join the group to access this section',
        })
      }

      if (
        !GroupState.state?.role ||
        GroupState.state?.userStatus !== MemberStatus.ACTIVE
      ) {
        router.push({
          name: 'private-group',
          params: { groupSlug: route.params.groupSlug },
          query: route.query,
        })
        const configuredRoute = navigation.state.navigationItems.filter(
          item => {
            return item.routeName.includes(route.name as string)
          }
        )
        if (
          routeFrom?.path &&
          configuredRoute &&
          configuredRoute.length > 0 &&
          routeFrom?.params?.groupSlug === route?.params?.groupSlug
        ) {
          emitter.emit('route-change:show-access-information')
        }
      }
    }
    if (
      route.name === 'private-group' &&
      GroupState.state?.role &&
      GroupState.state.userStatus === MemberStatus.ACTIVE
    ) {
      await router.push({
        name: 'home',
        params: { groupSlug: route.params.groupSlug },
        query: route.query,
      })
    }
  }

  static async handleBannedUser(route, router): Promise<void> {
    const slug = GroupState?.state?.groupData?.slug
    if (
      GroupState?.state?.userStatus === MemberStatus.BANNED &&
      route.name !== 'content-unavailable' &&
      slug &&
      decodeURIComponent(route.path).includes(slug)
    ) {
      await router.push({ name: 'content-unavailable' })
    }
  }

  static checkAndShowMandatoryInfoModel(): void {
    const mandatoryInfoPresent = UserState.checkMandatedInfoPresentOrNot()
    UserState.setMandatoryInfoModal(!mandatoryInfoPresent)
  }
}
